var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent",attrs:{"id":"app"}},[_c('loader',{attrs:{"isLoading":_vm.loading}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }